// extracted by mini-css-extract-plugin
module.exports = {"Summary":"Summary_Summary__2p4Df","part":"Summary_part__1qDiM"};